import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import ChevronLeftRounded from '@mui/icons-material/ChevronLeftRounded';
import Typography from '@mui/material/Typography';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => {
        navigate('../terminal-locator/');
      }}
      sx={{
        display: { xs: 'inline-flex' },
        justifyContent: 'flex-start',
        mb: 2,
        ml: -1,
        px: 0,
      }}
      variant="text"
    >
      <ChevronLeftRounded color="secondary.main" sx={{ mt: '-2px' }} />
      <Typography color="secondary.main" variant="caption">
        Back to Search Results
      </Typography>
    </Button>
  );
};

export default BackButton;
